import { ANALYTICS } from '@/config';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export function initSession() {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  const hasUtm = UTM_KEYS.some((k) => params.get(k));
  if (hasUtm && !sessionStorage.getItem('ppv_utm')) {
    const utm = {};
    UTM_KEYS.forEach((k) => (utm[k] = params.get(k) || ''));
    sessionStorage.setItem('ppv_utm', JSON.stringify(utm));
  }
  if (!sessionStorage.getItem('ppv_landing')) {
    sessionStorage.setItem('ppv_landing', window.location.href);
  }
}

export function getUtm() {
  try {
    return JSON.parse(sessionStorage.getItem('ppv_utm') || '{}');
  } catch {
    return {};
  }
}

export function getLandingUrl() {
  return sessionStorage.getItem('ppv_landing') || window.location.href;
}

export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
  if (typeof window.fbq === 'function') {
    window.fbq('trackCustom', name, params);
  }
}

export function initAnalytics() {
  if (typeof window === 'undefined') return;
  if (ANALYTICS.GTM) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${ANALYTICS.GTM}`;
    document.head.appendChild(s);
  } else if (ANALYTICS.GA4) {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ANALYTICS.GA4}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', ANALYTICS.GA4);
  }
  if (ANALYTICS.META) {
    const n = (window.fbq = window.fbq || function () { n.queue.push(arguments); });
    n.queue = n.queue || [];
    n.loaded = true; n.version = '2.0';
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(s);
    window.fbq('init', ANALYTICS.META);
    window.fbq('track', 'PageView');
  }
}
